module.exports = "https://static.wmbcdn.com/uniweb/images/ae3faca22a59994877d447b450983acc.svg";